<template>
  <v-col>
    <v-tabs centered>
      <v-tab>Sale Terms and Conditions</v-tab>
      <v-tab>Edit</v-tab>
      <v-tab-item>
        <v-row>
          <v-col
            class="text-center"
            cols="12"
          >
            <v-chip
              v-for="term in polices.split(',')"
              :key="term"
              class="mb-1 ml-1"
            >
              <v-icon left>
                mdi-bookmark-check
              </v-icon>
              {{ term }}
            </v-chip>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-textarea v-model="polices" />
        <v-btn
          class="info mt-3"
          @click="policesUpdate"
        >
          Update polices
        </v-btn>
      </v-tab-item>
    </v-tabs>
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      polices: "",
    };
  },
  computed: {
    ...mapGetters({
      terms: "configs/terms",
    }),
  },
  mounted() {
    const data = this.terms.saleTerms;
    if (data !== null) {
      this.$data.polices = data;
    }
  },
  methods: {
    policesUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-terms-update",
        payload: { saleTerms: this.polices },
      });
    },
  },
};
</script>
